// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"363":"67538fc194c20807","888":"70ca18ba50d43ca7","901":"1d744ab05becf2ed"}[chunkId] + ".css";
};